import PropTypes from 'prop-types'
import ReactApexChart from 'react-apexcharts'
import { connect } from 'react-redux'

//TODO , MAKE A CHART COMPONENT THAT CAN BE USED IN BOTH DASHBOARDS
export const OffersChart = ({ labels, series, maxOffers, maxParts, leftYAxisText, rightYAxisText }) => {
	const BAR_COLOR = '#c0fae3'
	const BIG_BAR_COLOR = '#27e372'
	const LINE_COLOR = '#c5d3fa'
	const BIG_LINE_COLOR = '#4a77ff'

	const BAR_BORDER = 0
	const BIG_BAR_BORDER = 1
	const LINE_WIDTH = 3
	const BIG_LINE_WIDTH = 3
	const options = {
		colors: [BAR_COLOR, BIG_BAR_COLOR, BIG_LINE_COLOR, LINE_COLOR], //color linea pequeña, color borde barra, color linea gorda
		chart: {
			type: 'line',
			stacked: false,
			height: 350,
			toolbar: { show: false },
		},
		stroke: {
			width: [BAR_BORDER, BIG_BAR_BORDER, BIG_LINE_WIDTH, LINE_WIDTH], // [borde barra pequeña, borde barra grande, linea gorda, linea pequeña
			curve: 'smooth',
		},
		plotOptions: {
			bar: {
				columnWidth: '81%',
			},
		},
		labels,
		markers: {
			size: 0,
		},
		yaxis: [{
			max: maxOffers,
			title: {
				text: leftYAxisText,

			},
		}, {
			max: maxOffers,
			show: false,
		}, {
			opposite: true,
			max: maxParts,
			title: {
				text: rightYAxisText,
			},
		},
		{
			show: false,
			max: maxParts,
		}],

		tooltip: {
			shared: true,
			intersect: false,
			y: {
				formatter: function (y) {
					if (typeof y !== 'undefined') {
						return y.toFixed(0)
					}
					return y

				},
			},
		},
	}

	return (
		<div style={{ height: '42.5rem' }}>
			<ReactApexChart height={'100%'} options={options} series={series} type="line" />

		</div>
	)
}

OffersChart.propTypes = {
	series: PropTypes.array,
	labels: PropTypes.array,
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(OffersChart) 
